import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();
  
  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 2,
        mt: 'auto',
        textAlign: 'center',
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        position: 'relative',
        zIndex: 1,
      }}
    >
      <Typography variant="body2" color="text.secondary">
        Tulidu.com {t('footer.copyright', { year: currentYear })}{' '}
        <Link 
          href="/privacy-policy.html" 
          color="inherit" 
          underline="hover"
          sx={{ textDecoration: 'none', mr: 1 }}
        >
          Privacy Policy
        </Link>
        |
        <Link 
          href="/terms-of-service.html" 
          color="inherit" 
          underline="hover"
          sx={{ textDecoration: 'none', mx: 1 }}
        >
          Terms of Service
        </Link>
        |
        <Link 
          href="/EULA.html" 
          color="inherit" 
          underline="hover"
          sx={{ textDecoration: 'none', ml: 1 }}
        >
          {t('footer.eula')}
        </Link>
      </Typography>
    </Box>
  );
};

export default Footer; 